import React, { useContext, useEffect, useState } from 'react';
import { Box, Link, styled, Typography } from '@mui/material';
import AppLogo from '../assets/AMOLogo.svg';
import { useTranslation } from 'react-i18next';
import logoutIcon from '../assets/Logoff.svg';
import { StyledColumnBox, StyledRowBox, StyledYellowButton } from '../theme/StyledElements';
import { LogoutModal } from './LogoutModal';
import { UserContext } from '../providers/UserProvider';

const StyledHeader = styled(StyledRowBox)(() => ({
    bottom: '0px',
    left: '0px',
    right: '0px',
    width: '100vw',
    padding: '0px 100px',
    margin: '20px 20px 0px 0px',
    justifyContent: 'space-between',
    borderBottom: '2px solid #E37F1E',
    height: '80px'
}));

const StyledCompanyHeader = styled(Typography)(() => ({
    letterSpacing: '0px',
    color: '#134C03'
}));

const StyledImage = styled('img')(() => ({
    height: '62px',
    width: '80px',
    margin: '3px',
    marginLeft: '20px'
}));

const StyledLogoutIcon = styled('img')(() => ({
    height: '25px',
    width: '25px',
    marginRight: '5px'
}));

const StyledTabs = styled(Link)(() => ({
    letterSpacing: '0px',
    color: '#134C03',
    padding: '10px',
    fontWeight: 700,
    textDecoration: 'none'
}));

const StyledTabBar = styled(Box)(() => ({
    width: '100vw',
    borderBottom: '2px solid #E37F1E',
    display: 'flex',
    justifyContent: 'center'
}));

interface NavbarProps {
    activeStep: number;
    id?: string;
}

export function Navbar({ activeStep, id }: NavbarProps): React.ReactElement {
    const { t } = useTranslation();
    const [active, setActive] = useState(activeStep);
    const [basketId, setBasketId] = useState(id);
    const user = useContext(UserContext);
    const [logout, setLogout] = useState<boolean>(false);

    useEffect(() => {
        setBasketId(id);
    }, [id]);

    return (
        <StyledColumnBox>
            <LogoutModal
                isModelOpen={logout}
                setModelOpen={setLogout}
                onCancelClick={(): void => {
                    setLogout(false);
                }}
            />
            <StyledHeader>
                <StyledImage src={AppLogo} />
                <Box style={{ marginTop: '20px', textAlign: 'center' }}>
                    <StyledCompanyHeader variant="h3">
                        {user?.prenom} {user?.nom}
                    </StyledCompanyHeader>
                    <StyledCompanyHeader variant="h5" sx={{ fontWeight: 500 }}>
                        {user?.nomFerme}
                    </StyledCompanyHeader>
                </Box>
                <StyledYellowButton type="button" onClick={(): void => setLogout(true)}>
                    <StyledLogoutIcon src={logoutIcon} />
                    <Typography variant="h5">{t('logout')}</Typography>
                </StyledYellowButton>
            </StyledHeader>
            <StyledTabBar>
                <StyledTabs
                    href="/"
                    variant="h5"
                    sx={{
                        borderBottom: active === 0 ? '5px solid #E37F1E' : '',
                        marginLeft: '-100px'
                    }}
                    onClick={(): void => setActive(0)}>
                    {t('overview')}
                </StyledTabs>
                <StyledTabs
                    href={`/view-basket/${basketId}`}
                    variant="h5"
                    sx={{ borderBottom: active === 1 ? '5px solid #E37F1E' : '' }}
                    onClick={(): void => setActive(1)}>
                    {t('myBaskets')}
                </StyledTabs>
                <StyledTabs
                    href="/view-farm"
                    variant="h5"
                    sx={{ borderBottom: active === 2 ? '5px solid #E37F1E' : '' }}
                    onClick={(): void => setActive(2)}>
                    {t('myFarm')}
                </StyledTabs>
            </StyledTabBar>
        </StyledColumnBox>
    );
}
